import { Outlet } from "react-router-dom";
import Footer from "../../components/marketing/footer/Footer";

export default function IcfLayout() {
  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
}